export default "__VITE_ASSET__80587e27__"